import { render, staticRenderFns } from "./shareButton.vue?vue&type=template&id=70b10598&scoped=true&"
import script from "./shareButton.vue?vue&type=script&lang=js&"
export * from "./shareButton.vue?vue&type=script&lang=js&"
import style0 from "./shareButton.vue?vue&type=style&index=0&id=70b10598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b10598",
  null
  
)

export default component.exports